<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >

    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-container v-else fluid>
    <v-row cols="12" class="v-card v-sheet theme--light mx-auto fill-height" :style="`min-height: calc(100vh - 24px - ${!$store.state.auth.default_user ? '0px' : '24px'})`">
      <v-col :cols="autobonus ? 8 : 12" class="transition-ease-in-out">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filteredItems"
          :disable-pagination="true"
          fixed-header
          hide-default-footer
          single-select
          show-select
          item-key="event_id"
          @item-selected="selectAutobonus"
          class="th-nowrap"
          :height="`calc(100vh - 120px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        >
          <template v-slot:item.amount="{ item }">
            {{ item.amount + (item.amount_prefix === 'P' ? '%' : '') }}
          </template>
          <template v-slot:item.affiliate="{ item }">
            {{ item.rules.affiliate }}
          </template>
          <template v-slot:item.date_start="{ item }">
            <span class="nowrap">{{ item.date_start }}</span>
          </template>
          <template v-slot:item.date_end="{ item }">
            <span class="nowrap">{{ item.date_end }}</span>
          </template>
          <template v-slot:top>
            <v-row class="mx-auto">
              <select-project
                v-model="entity_id"
              >
              </select-project>
              <v-checkbox
                label="Hide Inactive"
                v-model="hideInactive"
                hide-details
                class="ml-2"
              />
              <v-spacer></v-spacer>

              <v-btn
                v-if="$store.state.auth.checkAccess({key: 'autobonus_update', value: true})"
                class="mt-3"
                color="success"
                @click="newAutobonus()">
                <v-icon left>mdi-pencil</v-icon>
                New
              </v-btn>
            </v-row>
          </template>

        </v-data-table>
      </v-col>
      <v-col cols="4" class="transition-ease-in-out" :hidden="!autobonus">
        <update-form :autobonus="autobonus" :loading="loadingAutobonus" @update-validation="updateFormValidation" class="overflow-y-auto" :style="`height: calc(100vh - 84px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"></update-form>

        <v-row class="mx-auto px-6">
          <v-btn
            v-if="$store.state.auth.checkAccess({key: 'autobonus_update', value: true})"
            :loading="loadingAutobonus"
            :disabled="!validUpdateForm"
            @click="save()"
            color="primary"
          >Save
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loadingAutobonus"
            @click="autobonus = false; selected= [];"
            color="warning"
          >Close
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
  .nowrap,
  .th-nowrap th {
    white-space: nowrap;
  }
</style>

<script>
  import { API } from '@/utils/api'
  import { map, cloneDeep, filter } from 'lodash'
  import moment from 'moment'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    components: {
      SelectProject,
      UpdateForm: () => import('@/components/autobonus/UpdateForm'),
    },

    data: () => ({
      autobonus: false,
      hideInactive: true,
      validUpdateForm: false,
      loadingAutobonus: false,
      selected: [],
      entity_id: null,
      headers: [
        { text: 'ID', value: 'event_id', sortable: true },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Comment', sortable: false, value: 'comment' },
        { text: 'Amount', sortable: false, value: 'amount' },
        { text: 'Wager', sortable: false, value: 'rules.wager' },
        { text: 'Start', sortable: false, value: 'date_start' },
        { text: 'End', sortable: false, value: 'date_end' },
        { text: 'Trigger', sortable: false, value: 'trigger' },
        { text: 'Currency', sortable: false, value: 'currency' },
        { text: 'Affiliate', sortable: false, value: 'affiliate' },
      ],
      items: [],
    }),

    computed: {
      filteredItems () {
        if (this.hideInactive) {
          return filter(this.items, (o) => (moment(o.date_end) >= moment()))
        } else {
          return this.items
        }
      },
    },

    watch: {
      entity_id (val) {
        this.entity_id = val
        this.loadAutobonusList()
      }
    },

    methods: {
      updateFormValidation (value) {
        this.validUpdateForm = value
      },
      async save () {
        if (!(await this.$root.$confirm('Confirm', 'Are you sure you want to save?'))) {
          return
        }

        this.loadingAutobonus = true
        API.call('/$v/autobonus/update.json', { autobonus: this.autobonus }, null, this.autobonus.entity_id)
          .then(resp => {
            this.autobonus = resp.data
            this.autobonus.amount = this.autobonus.amount + (this.autobonus.amount_prefix === 'P' ? '%' : '')
            if (this.autobonus.rules.sport) {
              this.autobonus.rules.sport.amount = this.autobonus.rules.sport.amount + (this.autobonus.rules.sport.amount_prefix === 'P' ? '%' : '')
            }
            return resp
          })
          .then(resp => this.loadAutobonusList())
          .catch(e => {
          }).finally(() => {
          this.loadingAutobonus = false
        })
      },
      newAutobonus () {
        this.autobonus = { new: true, rules: { country: [] }, entity_id: this.entity_id }
        this.loadingAutobonus = false
        this.selected = []
      },

      loadAutobonusList () {
        return API.call('/$v/autobonus/list.json', {}, null, this.entity_id).then(resp => {
          this.items = resp.data
        })
      },

      selectAutobonus (data) {
        this.autobonus = data.value ? cloneDeep(data.item) : false

        if (this.autobonus) {
          this.autobonus.amount = this.autobonus.amount + (this.autobonus.amount_prefix === 'P' ? '%' : '')
          if (this.autobonus.rules.sport) {
            this.autobonus.rules.sport.amount = this.autobonus.rules.sport.amount + (this.autobonus.rules.sport.amount_prefix === 'P' ? '%' : '')
          }
          if (this.autobonus.rules.overdraft) {
            this.autobonus.rules.overdraft.amount = this.autobonus.rules.overdraft.amount + (this.autobonus.rules.overdraft.amount_prefix === 'P' ? '%' : '')
          }
        }
      }
    }
  }
</script>
